import { Type } from "class-transformer";
import { observable } from "mobx";
import Enum from "./enum";
import FuelType from "./fuelType";
import LocalizedFuelTypeResponse from "./localizedFuelTypeResponse";

export default class FuelTypeResponse extends Enum {
  /**
   * Fuel type ID.
   */
  id!: string;

  @observable
  fuelType!: FuelType;

  /**
   * Fuel type name in default language.
   */
  @observable
  name!: string;

  /**
   * Indicates whether fuel type is deleted.
   */
  @observable
  isDeleted!: boolean;

  /**
   * List of localized fuel type data.
   */
  @observable
  @Type(() => LocalizedFuelTypeResponse)
  localizations!: LocalizedFuelTypeResponse[];
}
